import type { FxFlexiForward } from '@/store/flexi-forward/state.ts';
import type { AppState } from '@/store/store.ts';

export const selectFlexiForwardTile = (state: AppState, tileId: string) => {
  return state.flexiForward[tileId] as FxFlexiForward | undefined;
};
